import LineDiyHttpRequest from './LineDiyServiceRequest'

export default class TaxAgentProvider extends LineDiyHttpRequest {
  createTaxAgent (data) {
    return this.axiosInstance.post('/tax-agent', data)
  }

  getTaxAgentByTaxId (taxId) {
    return this.axiosInstance.get(`/tax-agent/${taxId}`)
  }

  updateTaxAgent (taxId, data) {
    return this.axiosInstance.put(`/tax-agent/${taxId}`, data)
  }
}
